import Icon from "@Atom/Icon";
import Styles from "./styles.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import Images from "@Theme/Images";

import ModalWrapper from "@Atom/ModalWrapper";
import EditInformationModal from "./EditInformationModal";
import useQuery from "@Hooks/useQuery";
import HomeFooter from "../Business/HomeFooter";
import { updateProfile, userLogin } from "@Services/home";

import OTPConfirmationModal from "@Molecule/_modal/OTPConfirmationModal";
import useWindowSize from "@Hooks/useWindowSize";
import HeaderComponent from "@Molecule/Header";
import ProfileMenu from "./ProfileMenu";
import PermataWorkHistory from "./PermataWorkHistory";
import ArchivedApplication from "./ArchivedApplications";
import AddLinkVideoModal from "@Molecule/_modal/AddLinkVideoModal";
import OtherCompanyJobPosting from "./OtherCompany";

export default function SettingProfileUser({ data, sync }) {
  const user = {
    name: localStorage.getItem("username"),
    position: localStorage.getItem("role"),
    accessToken: localStorage.getItem("accessToken"),
    accessTokenUserLanding: localStorage?.getItem("accessTokenUserLanding"),
    nameUserLanding: localStorage?.getItem("nameUserLanding"),
    phoneNumberUserLanding: localStorage?.getItem("phoneNumberUserLanding"),
    emailUserLanding: localStorage?.getItem("emailUserLanding"),
    dataProfile: localStorage?.getItem("dataProfile"),
    profilePicture: localStorage?.getItem("profilePictUserLanding"),
  };

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { width } = useWindowSize();
  const query = useQuery();

  const [trigger, setTrigger] = useState(query?.get("tr") || "");
  const [hash, setHash] = useState(query?.get("h") || "");
  const [phoneNumber, setPhoneNumber] = useState(query?.get("p") || "");
  const [typeOtp, setTypeOtp] = useState(query?.get("ty") || "");
  const defaultSelectedMenu =
    query?.get("fr") ||
    sessionStorage?.getItem("selectedMenuSettingLanding") ||
    "Profil Saya";
  const [selectedMenu, setSelectedMenu] = useState(
    defaultSelectedMenu || "Profil Saya"
  );

  useEffect(() => {
    navigate(
      `${pathname}?tr=${trigger || ""}&h=${hash || ""}&p=${
        phoneNumber || ""
      }&ty=${typeOtp || ""}&fr=${selectedMenu || ""}`
    );
  }, [trigger, pathname, navigate, hash, phoneNumber, typeOtp, selectedMenu]);

  const [editPhotoProfile, setEditPhotoProfile] = useState(false);
  const [editInformationPersonal, setEditInformationPersonal] = useState(false);
  const [editInformationContact, setEditInformationContact] = useState(null);
  const [editWorkExperience, setEditWorkExperience] = useState(null);
  const [addWorkExperience, setAddWorkExperience] = useState(false);
  const [addOtherFiles, setAddOtherFiles] = useState(null);
  const [editOtherFiles, setEditOtherFiles] = useState(null);
  const [modalLinkVideo, setModalLinkVideo] = useState(false);

  const inputCvRef = useRef();
  const inputPhotoProfileRef = useRef();
  const inputOtherRef = useRef();
  const inputEditOtherRef = useRef();

  const optionsMenu = [
    {
      id: 1,
      name: "Profil Saya",
      icon: "user-circle",
    },
    {
      id: 2,
      name: "Pekerjaan Dilamar",
      icon: "contracted",
      subMenu: [
        {
          id: 1,
          name: "Permata Indonesia",
          img: Images.PERMATA_LOGO,
          icon: false,
        },
        {
          id: 2,
          name: "Perusahaan Lain",
          img: "other-company",
          icon: true,
        },
      ],
    },
    {
      id: 3,
      name: "Loker Disimpan",
      icon: "archive",
    },
  ];

  const defaultSelectedSubMenu =
    sessionStorage?.getItem("selectedSubMenuSettingLanding") || "";
  const [selectedSubMenu, setSelectedSubMenu] = useState(
    defaultSelectedSubMenu || ""
  );

  useEffect(() => {
    sessionStorage?.setItem("selectedMenuSettingLanding", selectedMenu);
    sessionStorage?.setItem("selectedSubMenuSettingLanding", selectedSubMenu);
  }, [selectedMenu, selectedSubMenu]);

  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e, payload, type) => {
    try {
      e?.preventDefault();
      if (type === "email" || type === "phoneNumber") {
        setLoading(type);

        const { response } = await userLogin({
          emailOrPhoneNUmber: payload,
          type: type,
        });
        setLoading("");
        // setTrigger(Math.random());
        setHash(response);
        setPhoneNumber(payload);
        setError("");
        setTypeOtp(type);
      } else {
        const formData = new FormData();
        if (type === "CV") {
          setLoading(type);
          if (
            payload?.CandidateAccountDocuments?.length > 0 &&
            payload?.CandidateAccountDocuments?.find((el) => el?.label === "CV")
          ) {
            formData?.append(
              "accountDocuments[0][id]",
              payload?.CandidateAccountDocuments?.find(
                (el) => el?.label === "CV"
              )?.id || ""
            );
          }

          formData?.append(
            "accountDocuments[0][action]",
            payload?.CandidateAccountDocuments?.length > 0 &&
              payload?.CandidateAccountDocuments?.find(
                (el) => el?.label === "CV"
              )
              ? "UPDATE"
              : "CREATE"
          );
          formData?.append("accountDocuments[0][label]", type || "");
          formData?.append(
            "accountDocuments[0][file]",
            e?.target?.files[0] || ""
          );
        } else if (type === "PROFILE") {
          setLoading(type);
          formData?.append("profilePic", e?.target?.files[0] || "");
        } else if (type === "Otherdocument") {
          setLoading(payload?.id);
          formData?.append("accountDocuments[0][id]", payload?.id || "");
          formData?.append("accountDocuments[0][action]", "DELETE" || "");
        } else if (type === "video") {
          setLoading(type);

          if (
            data?.CandidateAccountDocuments?.length > 0 &&
            data?.CandidateAccountDocuments?.find(
              (el) => el?.label?.toLowerCase() === "video"
            )
          ) {
            formData.append(
              "videoProfile[id]",
              data?.CandidateAccountDocuments?.find(
                (el) => el?.label?.toLowerCase() === "video"
              )?.id
            );
          }

          formData.append(
            "videoProfile[action]",
            data?.CandidateAccountDocuments?.length > 0 &&
              data?.CandidateAccountDocuments?.find(
                (el) => el?.label?.toLowerCase() === "video"
              )
              ? "UPDATE"
              : "CREATE"
          );
          formData.append("videoProfile[url]", payload);
          formData.append("videoProfile[label]", type?.toUpperCase());
        } else {
          setLoading(payload?.id);
          formData?.append("workExperience[0][id]", payload?.id || "");
          formData?.append("workExperience[0][action]", "DELETE" || "");
        }

        const { response } = await updateProfile(formData);
        localStorage?.setItem(
          "profilePictUserLanding",
          response?.updatedAccount?.profilePic || ""
        );
        setLoading("");
        setTrigger(Math.random());
        setError("");
        setModalLinkVideo(false);
      }
    } catch (error) {
      console.log(error);
      setLoading("");
      setError(error.response?.data?.error);
    }
  };

  const content = useMemo(() => {
    switch (selectedMenu) {
      case "Profil Saya":
        return (
          <ProfileMenu
            setEditPhotoProfile={setEditPhotoProfile}
            inputPhotoProfileRef={inputPhotoProfileRef}
            handleSubmit={handleSubmit}
            data={data}
            editPhotoProfile={editPhotoProfile}
            loading={loading}
            trigger={trigger}
            query={query}
            setEditInformationContact={setEditInformationContact}
            setEditInformationPersonal={setEditInformationPersonal}
            inputCvRef={inputCvRef}
            inputOtherRef={inputOtherRef}
            setAddOtherFiles={setAddOtherFiles}
            inputEditOtherRef={inputEditOtherRef}
            setEditOtherFiles={setEditOtherFiles}
            setAddWorkExperience={setAddWorkExperience}
            setEditWorkExperience={setEditWorkExperience}
            setModalLinkVideo={setModalLinkVideo}
          />
        );

      case "Pekerjaan Dilamar":
      case "Permata Indonesia":
        return <PermataWorkHistory />;
      case "Perusahaan Lain":
        return <OtherCompanyJobPosting />;
      case "Loker Disimpan":
        return <ArchivedApplication />;

      default:
        return null;
    }
  }, [
    selectedMenu,
    editPhotoProfile,
    data,
    trigger,
    query,
    loading,
    handleSubmit,
    inputCvRef,
    inputPhotoProfileRef,
    inputOtherRef,
    inputEditOtherRef,
    setEditPhotoProfile,
    setEditInformationContact,
    setEditInformationPersonal,
    setAddOtherFiles,
    setEditOtherFiles,
    setAddWorkExperience,
    setEditWorkExperience,
    setModalLinkVideo,
  ]);

  useEffect(() => {
    if (
      editInformationPersonal ||
      editWorkExperience ||
      addWorkExperience ||
      addOtherFiles ||
      query?.get("h") ||
      modalLinkVideo
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
  }, [
    editInformationPersonal,
    editWorkExperience,
    addWorkExperience,
    addOtherFiles,
    query,
    modalLinkVideo,
  ]);

  return (
    <>
      {width <= 820 && (
        <HeaderComponent
          user={user}
          selectedMenu={selectedMenu}
          setSelectedMenu={setSelectedMenu}
          selectedSubMenu={selectedSubMenu}
          setSelectedSubMenu={setSelectedSubMenu}
        />
      )}
      <div className={Styles.container}>
        <div className={Styles.header}>
          <div className={Styles.inner}>
            <div
              className={Styles.routes}
              onClick={() => {
                navigate("/");
              }}
            >
              <div>
                <Icon
                  icon={"arrow-left"}
                  size={16}
                  // color={"#FFFFFF"}
                  className={Styles.iconBack}
                />
              </div>
              <span>Kembali Ke Beranda</span>
            </div>
          </div>
        </div>

        <div className={Styles.content}>
          <div className={Styles.left}>
            <span>Menu</span>
            <div>
              {optionsMenu?.map((el, idx) => (
                <div className={Styles.listMenuWrapper} key={idx}>
                  <div
                    className={`${Styles.listMenu} ${
                      selectedMenu === el?.name && Styles.active
                    }`}
                    onClick={() => {
                      if (selectedMenu !== el?.name && !el?.subMenu) {
                        setSelectedMenu(el?.name);
                        setSelectedSubMenu("");
                      } else if (el?.subMenu && el?.subMenu?.length > 0) {
                        if (selectedSubMenu !== el?.name) {
                          setSelectedSubMenu(el?.name);
                        } else {
                          setSelectedSubMenu("");
                        }
                      }
                    }}
                  >
                    <div
                      className={`${Styles.leftListMenu} ${
                        selectedMenu === el?.name && Styles.active
                      } ${selectedSubMenu === el.name && Styles.active}`}
                    >
                      <div>
                        <Icon
                          icon={el?.icon}
                          size={20}
                          className={Styles.icon}
                        />
                      </div>
                      <span>{el?.name}</span>
                    </div>

                    {el?.subMenu && el?.subMenu?.length > 0 && (
                      <div className={Styles.arrow}>
                        <Icon
                          icon={
                            selectedSubMenu === el.name
                              ? "arrow-up"
                              : "arrow-down"
                          }
                          size={16}
                          color={"#0A0A0A"}
                        />
                      </div>
                    )}
                  </div>

                  {selectedSubMenu === el?.name && el?.subMenu && (
                    <div className={Styles.subMenuBox}>
                      <div className={Styles.line}></div>
                      <div className={`${Styles.subMenu}`}>
                        {el?.subMenu?.map((submenu, idsubMenu) => {
                          return (
                            <div
                              key={idsubMenu}
                              onClick={() => {
                                if (selectedMenu !== submenu?.name) {
                                  setSelectedMenu(submenu?.name);
                                }
                              }}
                              className={`${Styles.list} ${
                                selectedMenu === submenu?.name && Styles.active
                              }`}
                            >
                              <div className={Styles.images}>
                                {submenu?.icon ? (
                                  <Icon
                                    icon={submenu?.img}
                                    size={20}
                                    color={"#404040"}
                                  />
                                ) : (
                                  <img src={submenu?.img} alt="" />
                                )}
                              </div>
                              <span>{submenu?.name || "-"}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          {content}
        </div>

        {modalLinkVideo && (
          <ModalWrapper
            show={modalLinkVideo}
            handleClose={() => {}}
            isLandingPage
          >
            <AddLinkVideoModal
              error={error}
              loading={loading === "video"}
              handleClose={() => setModalLinkVideo(false)}
              linkUrl={
                data?.CandidateAccountDocuments?.length > 0 &&
                data?.CandidateAccountDocuments?.find(
                  (el) => el?.label?.toLowerCase() === "video"
                )?.url
                  ? data?.CandidateAccountDocuments?.find(
                      (el) => el?.label?.toLowerCase() === "video"
                    )?.url
                  : ""
              }
              handleSubmit={handleSubmit}
            />
          </ModalWrapper>
        )}

        {editInformationPersonal && (
          <ModalWrapper
            show={editInformationPersonal}
            handleClose={() => {}}
            isLandingPage
          >
            <EditInformationModal
              data={data}
              sync={sync}
              handleClose={() => setEditInformationPersonal(false)}
              setTrigger={setTrigger}
              trigger={trigger}
            />
          </ModalWrapper>
        )}

        {editWorkExperience && (
          <ModalWrapper
            show={editWorkExperience}
            handleClose={() => {}}
            isLandingPage
          >
            <EditInformationModal
              data={editWorkExperience}
              sync={sync}
              handleClose={() => setEditWorkExperience(null)}
              setTrigger={setTrigger}
              trigger={trigger}
              isEditWorkExperiences
            />
          </ModalWrapper>
        )}

        {addWorkExperience && (
          <ModalWrapper
            show={addWorkExperience}
            handleClose={() => {}}
            isLandingPage
          >
            <EditInformationModal
              data={null}
              sync={sync}
              handleClose={() => setAddWorkExperience(false)}
              setTrigger={setTrigger}
              trigger={trigger}
              isAddWorkExperiences
            />
          </ModalWrapper>
        )}

        {addOtherFiles && (
          <ModalWrapper
            show={addOtherFiles}
            handleClose={() => {}}
            isLandingPage
          >
            <EditInformationModal
              data={{
                otherFiles: addOtherFiles,
                data: data,
              }}
              sync={sync}
              handleClose={() => setAddOtherFiles(null)}
              setTrigger={setTrigger}
              trigger={trigger}
              isAddOtherFiles
            />
          </ModalWrapper>
        )}

        {editInformationContact && (
          <ModalWrapper
            show={editInformationContact}
            handleClose={() => {}}
            isLandingPage
          >
            <EditInformationModal
              data={{
                type: editInformationContact,
                data: data,
              }}
              sync={sync}
              handleClose={() => setEditInformationContact(null)}
              setTrigger={setTrigger}
              trigger={trigger}
              isEditInformationContact
              setHash={setHash}
              setPhoneNumberQuery={setPhoneNumber}
              setTypeOtp={setTypeOtp}
            />
          </ModalWrapper>
        )}

        {query?.get("h") && (
          <ModalWrapper show={query?.get("h")} handleClose={() => {}}>
            <OTPConfirmationModal
              setIsDone={() => {}}
              handleReset={(response) => {
                setHash(response);
                setPhoneNumber(query?.get("p"));
                setTrigger(Math?.random());
                setTypeOtp(query?.get("ty"));
              }}
              handleSubmit={() => {
                setHash("");
                setPhoneNumber("");
                setTrigger(Math?.random());
                setTypeOtp("");
              }}
              data={{
                phoneNumber: query?.get("p"),
              }}
              loading={+trigger !== +query?.get("tr")}
              isOther={query?.get("ty")}
            />
          </ModalWrapper>
        )}

        {editOtherFiles && (
          <ModalWrapper
            show={editOtherFiles}
            handleClose={() => {}}
            isLandingPage
          >
            <EditInformationModal
              data={{
                otherFiles: editOtherFiles?.file,
                data: data,
                id: editOtherFiles?.data?.id,
              }}
              sync={sync}
              handleClose={() => setEditOtherFiles(null)}
              setTrigger={setTrigger}
              trigger={trigger}
              isEditOtherFiles
            />
          </ModalWrapper>
        )}
        <HomeFooter />
      </div>
    </>
  );
}
